import React, {useContext, useEffect} from "react";
import {Link} from 'react-router-dom'
import {useForm, FormProvider} from "react-hook-form";

import Button from '@mui/material/Button';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';

import dayjs from 'dayjs';
import 'dayjs/locale/ro';

import * as TypeConvertor from '../../util/TypeConvertor';
import * as Consts from '../../constants/Consts';
import * as ReminderGen from '../../../utils/calculators/ReminderGeneratorIscir';
import * as DataPattern from '../../constants/DataPattern';
import * as CustomStyles from '../../styles/CustomStyles';
import CustomSelect from '../../custom/CustomSelectComponent'
import * as SelectTypes from '../../constants/CustomSelectTypes'
import * as ValidationMessages from '../../constants/ValidationMessages';
import * as AuthorizationFragment from './AuthzIscirFragmentComponent';
import BucketContext from "../../context/BucketContext";
import {formatAuthzIscirDates} from './AuthzHelper';
import { AuthzIscirAFCode } from "../../constants/Consts";
import * as AFFragment from '../../custom/AFFragment';


// const useConfirmDialog = () => {
//     const [open, setOpen] = React.useState(false);
//     const [saveCourseRegistration, setSaveCourseRegistration] = React.useState(null);
//     const [course, setCourse] = React.useState(null);

//     const openDialog = (saveCourse, updatedCourse) => {
//         setSaveCourseRegistration(() => e => saveCourse(e));
//         setCourse(updatedCourse);
//         setOpen(true);
//     };
//     const handleClose = () => {
//         setOpen(false);
//     };
//     const handleSubmit =() => {
//         saveCourseRegistration(course);
//     }

//     const props = {
//       open,
//       handleClose,
//       handleSubmit
//     };
//     return [openDialog, props];
// };


// const ConfirmCompleteCourse = ({open, handleClose, handleSubmit}) => {
//     console.log('__ ConfirmCompleteCourse __');

//     const handleConfirmSubmit = () => {
//         handleClose();
//         handleSubmit();
//     }

//     return(
//         <React.Fragment>
//             <Dialog open={open} onClose={handleClose} maxWidth='md'>
//                 <DialogTitle>
//                     Confirmare
//                     <IconButton
//                         aria-label="close"
//                         onClick={handleClose}
//                         sx={{
//                             position: 'absolute',
//                             right: 8,
//                             top: 8,
//                             color: (theme) => theme.palette.grey[500],
//                         }}
//                         >
//                         <CloseIcon />
//                     </IconButton>
//                 </DialogTitle>
//                 <DialogContent dividers>
//                     <Typography color="text.primary" paddingTop={1} paddingLeft={1}>
//                         Confirmati completarea cursului!
//                     </Typography>
//                 </DialogContent>
//                 <DialogActions>
//                     <Button onClick={handleClose}>Inchide</Button>
//                     <Button onClick={handleConfirmSubmit} color="error" >Confirmare</Button>
//                 </DialogActions>
//             </Dialog>

//         </React.Fragment>
//     );
// }


// function CourseRegistrationManagementDialog(props) {
//     const { setValue, register, reset, handleSubmit, formState: { errors, defaultValues } } = useForm({
//         defaultValues: {
//             lCourseRegistration: props.courseRegistration,
//         } 
//     });

//     const [openConfirmDialog, confirmDialogProps] = useConfirmDialog();

//     const [dateCourseValue, setDateCourseValue] = React.useState(dayjs(`${defaultValues.lCourseRegistration.details?.dateCourse}`));
//     const [open, setOpen] = React.useState(false);

//     const handleClickOpen = () => {
//         setOpen(true);
//     };

//     const handleClose = () => {
//         setOpen(false);
//         reset();
//     };

//     const handleSubmitCourseRegUpdate = (data, event) => {
//         event.preventDefault();

//         const course = data.lCourseRegistration;
//         course.details.type = Consts.ExamType.CouponRenewal;
//         course.details.employeeId = props.employeeId;
//         course.details.workSiteId = props.workSiteId;

//         console.log(JSON.stringify(course));

//         if(course.details.courseStatus === CourseRegistrationStatus.Completed) {
//             console.log('Course completed !!!!!');
//             openConfirmDialog(props.saveCourseRegistration, course);
//         }
//         else {
//             props.saveCourseRegistration(course);
//             handleClose();
//         }

//     }    

//     // use 'ro' locale globally
//     dayjs.locale('ro');

//     return(
//         <React.Fragment>

//             <ConfirmCompleteCourse {...confirmDialogProps}/>

//             <Link
//                 component="button"
//                 variant="body2"
//                 onClick={handleClickOpen}
//             >
//                 {props.buttonName}
//             </Link>

//             <Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth={true}>
//                 <DialogTitle>
//                     Inregistrare curs
//                     <IconButton
//                         aria-label="close"
//                         onClick={handleClose}
//                         sx={{
//                             position: 'absolute',
//                             right: 8,
//                             top: 8,
//                             color: (theme) => theme.palette.grey[500],
//                         }}
//                         >
//                         <CloseIcon />
//                     </IconButton>
//                 </DialogTitle>
                
//                 <form id='courseRegistrationForm' onSubmit={ (event) => {
//                                                         event.stopPropagation(); 
//                                                         handleSubmit(handleSubmitCourseRegUpdate)(event);
//                                                     }}
//                 >
//                 <DialogContent dividers>

//                     <Grid container spacing={2} sx={CustomStyles.gridStyles}>
//                         {/*row*/}
//                         <Grid item xs={4}>
//                             <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ro'>
//                                 <DesktopDatePicker
//                                     // disabled={!!props.disabled ? props.disabled : false}
//                                     label="Data Inscriere la Curs"
//                                     inputFormat={DataPattern.DATE_FORMAT_RO}
//                                     format={DataPattern.DATE_FORMAT_RO}
//                                     value={dateCourseValue}
//                                     onChange={(newValue) => {
//                                         setDateCourseValue( dayjs(newValue) );
//                                         setValue('lCourseRegistration.details.dateCourse', newValue);
//                                     }}
//                                     renderInput={(params) => 
//                                         <TextField {...params} variant="standard" 
//                                             {...register('lCourseRegistration.details.dateCourse', {required: ValidationMessages.REQUITED_MESSAGE})}
//                                             error={!!errors?.lCourseRegistration?.details?.dateCourse}
//                                             helperText={errors?.lCourseRegistration?.details?.dateCourse ? errors.lCourseRegistration.details.dateCourse.message : null}
//                                             onChange={(event) => console.log("TextField Chage: " + event.target.value)}
//                                         />
//                                     }
//                                 />
//                             </LocalizationProvider>
//                         </Grid>
//                         <Grid item xs={8}>
//                             <TextField variant="standard" size="small" label="Furnizor Curs" fullWidth margin="dense" 
//                                 {...register("lCourseRegistration.details.courseProvider", {required: ValidationMessages.REQUITED_MESSAGE})} 
//                                 error={!!errors?.lCourseRegistration?.details?.courseProvider}
//                                 helperText={errors?.lCourseRegistration?.details?.courseProvider ? errors.lCourseRegistration.details.courseProvider.message : null}
//                             />
//                         </Grid>

//                         {/*row*/}
//                         <Grid item xs={12}>
//                             <TextField
//                                 variant="standard" 
//                                 id="outlined-multiline-static"
//                                 label="Observatii"
//                                 multiline fullWidth margin="dense" 
//                                 rows={4}
//                                 {...register("lCourseRegistration.details.notes")}
//                             />
//                         </Grid>

//                         {/*row*/}
//                         <Grid item xs={4}>
//                             <CustomSelect 
//                                 disabled={false}
//                                 selectId={'courseStatus'} 
//                                 selectType={SelectTypes.COURSE_REGISTRATION_STATUS} 
//                                 value={defaultValues.lCourseRegistration.details?.courseStatus} 
//                                 register={{...register('lCourseRegistration.details.courseStatus', {required: ValidationMessages.REQUITED_MESSAGE})}}
//                                 error={!!errors?.lCourseRegistration?.details?.courseStatus}
//                                 helperText={errors?.lCourseRegistration?.details?.courseStatus ? errors.lCourseRegistration.details.courseStatus.message : null}
//                             />
//                         </Grid>
//                         <Grid item xs={8}>
//                         </Grid>

//                     </Grid>
                
//                 </DialogContent>

//                 <DialogActions>
//                     {/* <Box sx={{ width:'50%'}} display="flex" justifyContent="flex-start" alignItems="flex-start">
//                         <DeleteAuthorizationISCIR authId={props.authorization.id} employeeId={props.authorization.autorizatie.employeeId} deleteAuthorization={props.deleteAuthorization} closeParentDialog={handleClose}/>
//                     </Box> */}
//                     <Box sx={{ width:'100%'}} display="flex" justifyContent="flex-end" alignItems="flex-end">
//                         <Button onClick={handleClose}>Inchide</Button>
//                         <Button type='submit'>Salveaza</Button>
//                     </Box>
//                 </DialogActions>
//                 </form>
//             </Dialog>

//         </React.Fragment>
//     );
// }


const AuthorizationIscirManagement = (props) => {
    console.log('AuthorizationISCIRManagement Component___');
    const bucketContext = useContext(BucketContext);

    useEffect(() => {

        if(bucketContext.bucket.mostRecentAuthzId != null) {
            console.log('Reseting the mostRecentAuthzId: ' + JSON.stringify(bucketContext.bucket.mostRecentAuthzId));
            bucketContext.setBucketValue({mostRecentAuthzId: null});
        }
    });


    const methods = useForm({
        defaultValues: {
            lAuthorization: props.authorization,
            employeeId: props.employee.id,
            employerId: props.employee.employmentDetails.employerId,
        } 
    });

    const register = methods.register;
    const handleSubmit = methods.handleSubmit;
    const errors = methods.formState.errors;
    const defaultValues = methods.formState.defaultValues;

    const [selectedAuthorization, setSelectedAuthorization] = React.useState(defaultValues.lAuthorization.autorizatie.authISCIR);


    const handleSubmitAuthzUpdate = (data, event) => {
        event.preventDefault();

        const authorization = data.lAuthorization;
        formatAuthzIscirDates(authorization);
        const reminder = ReminderGen.generateReminder(authorization, props.employer.preference);
        if(reminder) {
            authorization.reminder = ReminderGen.getAuthzReminder(reminder);
            reminder.id = authorization.id;
            reminder.extra = ReminderGen.getReminderExtra(props.employee, props.employer, props.worksite);
        }
        else {
            authorization.reminder = {};
        }

        props.saveAuthorization(authorization, reminder);
    }    

    // use 'ro' locale globally
    dayjs.locale('ro');

    const courseDescription = (course) => {
        var description = '';
        if(course) {
            description = dayjs(course.details.dateCourse).format(DataPattern.DATE_FORMAT_RO) +
                ' / ' +
                course.details.courseProvider;
        }

        return description;
    }

    const reminderType = () => {
        var type = '';
        if(props.authorization.reminder?.type) {
            switch(props.authorization.reminder.type) {
                case Consts.REMINDER_RENEW_COUPON_STAMP:
                    type = "Reinnoire Viza Talon";
                    break;
                case Consts.REMINDER_RENEW_COUPON:
                    type = "Reinnoire Talon";
                    break;
                case Consts.REMINDER_RENEW_AUTHORIZATION:
                    type = "Reinnoire Autorizatie";
                    break;
            }
        }

        return type;
    }

    const reminderDesc = () => {
        var desc = '';
        if(props.authorization.reminder?.type) {
            const remDt = dayjs(props.authorization.reminder.dataReminder).format(DataPattern.DATE_FORMAT_RO);
            const expDt = dayjs(props.authorization.reminder.dataExpirare).format(DataPattern.DATE_FORMAT_RO);
            desc =`Reminder: ${remDt} / Expira: ${expDt}`
        }

        return desc;
    }

    return(
        <Container maxWidth="xl" >
        <Box px={{xs: 3, sm: 7}}>

            <Stack spacing={1} sx={{marginBottom: 2}}>
                <Box>
                    <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                        <Link to={`/employees/${props.authorization.autorizatie.employeeId}`}>{props.employee.generalSection.lastName} {props.employee.generalSection.firstName}</Link>
                        <Typography color="text.primary">
                            Autorizatie ISCIR
                        </Typography>
                    </Breadcrumbs>
                </Box>       

                <Box>
                    <h3>{props.employee.generalSection.lastName} {props.employee.generalSection.firstName} - {TypeConvertor.getAuthzIscirName(props.authorization.autorizatie.authISCIR)}</h3>
                </Box>
                <hr/>

                <FormProvider {...methods} > 
                <form id='aaIscirConstructionForm' onSubmit={handleSubmit(handleSubmitAuthzUpdate)}>

                    <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                        {/*row*/}
                        <Grid item xs={12}>
                            <CustomSelect 
                                disabled={true}
                                // callback={handleAuthorizationChange}
                                selectId={'aaISCIR'} 
                                selectType={SelectTypes.ANGAJAT_AUTORIZAT_ISCIR} 
                                value={defaultValues.lAuthorization.autorizatie.authISCIR} 
                                register={{...register('lAuthorization.autorizatie.authISCIR', {required: ValidationMessages.REQUITED_MESSAGE})}}
                                error={!!errors?.lAuthorization?.autorizatie?.authISCIR}
                                helperText={errors?.lAuthorization?.autorizatie?.authISCIR ? errors.lAuthorization.autorizatie.authISCIR.message : null}
                            />
                        </Grid>

                    {
                        (() => {
                            if(selectedAuthorization == null){
                                return(
                                    <React.Fragment></React.Fragment>
                                );
                            }
                            else if(selectedAuthorization === AuthzIscirAFCode.OperatorRSVTI){
                                return(
                                    <AuthorizationFragment.AuthorizationRsvtiOperator disabled={true}/>
                                );
                            }
                            else{
                                return(
                                    <React.Fragment>
                                        <AuthorizationFragment.AuthorizationRsvtiStandard disabled={true}
                                            saveAuthzImage={props.saveAuthzImage}
                                        />
                                        <AuthorizationFragment.AuthorizationRsvtiTalon 
                                            rsvtiOperators={props.rsvtiOperators}
                                            saveAuthzImage={props.saveAuthzImage}
                                        />
                                    </React.Fragment>
                                );
                            }
                        })()
                    }

                        <Grid item xs={12} container justifyContent="flex-end" alignItems="flex-end">
                            <Button variant="outlined" type="submit" sx={{ marginRight: 1}}>Salveaza</Button>
                        </Grid>

                    </Grid>


                    <Grid container spacing={3} sx={CustomStyles.gridStyles}>
                        {/*row*/}
                        <Grid item xs={3}>
                            <Typography color="text.primary" paddingTop={0} >{reminderType()}</Typography>
                        </Grid>
                        <Grid item xs={9}>
                            <Typography color="text.primary" paddingTop={0} >{reminderDesc()}</Typography>
                        </Grid>

                        {/*row*/}
                        <Grid item xs={3}>
                            { props.course ? 
                                <Link to={`/employees/authzcourse/${props.course.id}`}>
                                    Curs
                                </Link>
                                :
                                <Link to={`/employees/newauthzcourse?employeeId=${props.authorization.autorizatie.employeeId}&authzId=${props.authorization.id}`}>
                                    Inregistrare Curs
                                </Link>
                            }
                        </Grid>
                        <Grid item xs={9}>
                            <Typography color="text.primary" paddingTop={0} >{courseDescription(props.course)}</Typography>
                        </Grid>
                    </Grid>

                    <AFFragment.UpdateDetailsSection entity={props.authorization}/>

                </form>
                </FormProvider>

            </Stack>

        </Box>
        </Container>
    );
}

export default AuthorizationIscirManagement;